export default __webpack_public_path__ + "static/media/game_bg1.2a7c6e8e.png";